import styled from "styled-components";
import { SPACING } from "../../constants/design/spacing";
import {
  BORDER_COLORS,
  TEXT_COLORS,
  BACKGROUND_COLORS,
} from "../../constants/design/colors";

export const EquityWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - 60px);
  overflow: auto;
  padding: ${SPACING.four}px;
`;

export const ChartContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 500px;
`;

export const ToggleContainer = styled.div`
  display: flex;
  gap: ${SPACING.two}px;
  margin-bottom: ${SPACING.three}px;
  justify-content: center;
`;

export const ToggleButton = styled.button<{ active: boolean }>`
  padding: ${SPACING.two}px ${SPACING.four}px;
  background-color: ${(props) =>
    props.active ? BACKGROUND_COLORS.four : BACKGROUND_COLORS.component};
  color: ${(props) => (props.active ? TEXT_COLORS.one : TEXT_COLORS.three)};
  border: 1px solid ${BORDER_COLORS.one};
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: ${(props) => (props.active ? "600" : "400")};
  transition: all 0.2s ease;

  &:hover {
    background-color: ${BACKGROUND_COLORS.four};
    color: ${TEXT_COLORS.one};
  }

  &:focus {
    outline: none;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  color: ${TEXT_COLORS.two};
  font-size: 16px;
`;

export const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  color: ${TEXT_COLORS.three};
  font-size: 16px;
`;

export const SummaryTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: ${SPACING.four}px;
  background-color: ${BACKGROUND_COLORS.component};
  border: 1px solid ${BORDER_COLORS.one};
  border-radius: 8px;
  overflow: hidden;
`;

export const SummaryTableHeader = styled.th`
  padding: ${SPACING.three}px ${SPACING.four}px;
  text-align: center;
  background-color: ${BACKGROUND_COLORS.four};
  color: ${TEXT_COLORS.one};
  font-weight: 600;
  font-size: 14px;
  border-bottom: 1px solid ${BORDER_COLORS.one};
`;

export const SummaryTableCell = styled.td`
  padding: ${SPACING.three}px ${SPACING.four}px;
  text-align: center;
  color: ${TEXT_COLORS.one};
  font-size: 16px;
  font-weight: 500;
`;
